export default {
  title: "Authentification",
  
  createAccount: {
    title: "Créer un compte",
    description: "Créez un compte pour gérer votre mariage",
    benefits: "Avantages de la création d'un compte",
    submit: "S'inscrire"
  },
  
  alreadyHaveAccount: "Vous avez déjà un compte ?",

  signInWithGoogle: "Se connecter avec Google",
  or: "ou",
  continueAsGuest: "Continuer en tant qu'invité",
  
  login: {
    title: "Connexion",
    description: "Connectez-vous à votre compte",
    form: {
      email: "Email",
      password: "Mot de passe",
      rememberMe: "Se souvenir de moi",
      submit: "Se connecter",
      forgotPassword: "Mot de passe oublié ?"
    },
    errors: {
      invalidCredentials: "Email ou mot de passe incorrect",
      userNotFound: "Aucun compte trouvé avec cet email",
      tooManyAttempts: "Trop de tentatives, veuillez réessayer plus tard"
    }
  },
  
  register: {
    title: "Inscription",
    description: "Créez votre compte",
    form: {
      firstName: "Prénom",
      lastName: "Nom",
      email: "Email",
      password: "Mot de passe",
      confirmPassword: "Confirmer le mot de passe",
      terms: "J'accepte les conditions d'utilisation",
      submit: "S'inscrire"
    },
    errors: {
      emailExists: "Un compte existe déjà avec cet email",
      passwordTooWeak: "Le mot de passe est trop faible",
      passwordsDontMatch: "Les mots de passe ne correspondent pas",
      termsNotAccepted: "Vous devez accepter les conditions d'utilisation"
    }
  },
  
  forgotPassword: {
    title: "Mot de passe oublié",
    description: "Réinitialisez votre mot de passe",
    form: {
      email: "Email",
      submit: "Envoyer le lien de réinitialisation"
    },
    success: "Un email de réinitialisation a été envoyé",
    errors: {
      userNotFound: "Aucun compte trouvé avec cet email",
      tooManyAttempts: "Trop de tentatives, veuillez réessayer plus tard"
    }
  },
  
  resetPassword: {
    title: "Réinitialiser le mot de passe",
    description: "Choisissez un nouveau mot de passe",
    form: {
      password: "Nouveau mot de passe",
      confirmPassword: "Confirmer le mot de passe",
      submit: "Réinitialiser le mot de passe"
    },
    success: "Votre mot de passe a été réinitialisé",
    errors: {
      invalidToken: "Le lien de réinitialisation est invalide ou a expiré",
      passwordTooWeak: "Le mot de passe est trop faible",
      passwordsDontMatch: "Les mots de passe ne correspondent pas"
    }
  },
  
  verifyEmail: {
    title: "Vérifier l'email",
    description: "Vérifiez votre adresse email",
    success: "Votre email a été vérifié",
    resend: "Renvoyer l'email de vérification",
    errors: {
      invalidToken: "Le lien de vérification est invalide ou a expiré",
      alreadyVerified: "Cet email est déjà vérifié"
    }
  },
  
  oauth: {
    google: "Continuer avec Google",
    facebook: "Continuer avec Facebook",
    apple: "Continuer avec Apple"
  },
  
  messages: {
    loggedIn: "Connecté avec succès",
    loggedOut: "Déconnecté avec succès",
    registered: "Compte créé avec succès",
    emailVerified: "Email vérifié avec succès",
    passwordReset: "Mot de passe réinitialisé avec succès"
  },

  logout: "Se déconnecter",
  
  // Clés utilisées dans les composants
  email: "Email",
  password: "Mot de passe",
  loginWithGoogle: "Se connecter avec Google",
  loginWithFacebook: "Se connecter avec Facebook",
  loginWithApple: "Se connecter avec Apple",
  signupWithGoogle: "S'inscrire avec Google",
  signupWithFacebook: "S'inscrire avec Facebook",
  signupWithApple: "S'inscrire avec Apple",
  loggingIn: "Connexion en cours...",
  continueWith: "ou continuer avec",
  protectedBy: "Protégé par",
  termsNotice: "En continuant, vous acceptez nos",
  termsOfService: "Conditions d'utilisation",
  and: "et",
  privacyPolicy: "Politique de confidentialité",
  
  // Vérification téléphone
  verifyPhone: "Vérifiez votre téléphone",
  verifyPhoneMessage: "Entrez votre numéro de téléphone pour recevoir un code de vérification par SMS",
  phoneNumber: "Numéro de téléphone",
  phoneNumberFormat: "Sans le premier zéro pour la France, ex: 612345678",
  skipStep: "Passer cette étape pour le moment",
  verifySms: "Vérifiez le code SMS",
  verifySmsMessage: "Nous avons envoyé un code à 6 chiffres au numéro",
  resendCodeIn: "Renvoyer le code dans",
  resendCode: "Renvoyer le code",
  
  // Vérification email
  verifyEmailMessage: "Nous avons envoyé un code à 6 chiffres à",
  verifyingEmail: "Vérification de l'email en cours...",
  verificationError: "Erreur de vérification",
  tryAgain: "Réessayer",
  emailVerified: "Email vérifié avec succès",
  redirecting: "Redirection en cours...",
  noCodeReceived: "Vous n'avez pas reçu de code ?",
  backToLogin: "Retour à la connexion",
  
  // Niveaux d'accès
  accessLevels: {
    view: "Lecture seule",
    edit: "Modification",
    manage: "Gestion complète"
  },
  
  // Informations d'accès
  accessInfo: {
    connectedAs: "Connecté en tant que"
  },
  
  // Restrictions d'accès
  accessRestriction: {
    title: "Accès restreint",
    insufficientLevel: "Niveau d'accès insuffisant",
    login: "Se connecter"
  },
  
  currentLevel: "Niveau actuel",
  requiredLevel: "Niveau requis",
  
  // Messages d'erreur
  errors: {
    suspiciousActivity: "Activité suspecte détectée. Veuillez réessayer.",
    recaptchaFailed: "La vérification de sécurité a échoué. Veuillez réessayer.",
    recaptchaUnavailable: "Le service de sécurité est temporairement indisponible. Veuillez réessayer plus tard.",
    recaptchaTimeout: "La vérification de sécurité a pris trop de temps. Veuillez vérifier votre connexion et réessayer.",
    accountExistsWithDifferentCredential: "Un compte existe déjà avec des identifiants différents",
    popupClosed: "La fenêtre de connexion a été fermée",
    disallowedUserAgent: "Agent utilisateur non autorisé",
    socialLoginFailed: "Échec de la connexion sociale",
    invalidPhone: "Numéro de téléphone invalide",
    genericError: "Une erreur s'est produite",
    invalidCode: "Code invalide, veuillez entrer les 6 chiffres.",
    loginFailed: "Échec de la connexion",
    googleLoginFailed: "Échec de la connexion Google",
    facebookLoginFailed: "Échec de la connexion Facebook",
    emailAlreadyInUse: "Cet email est déjà utilisé",
    invalidEmail: "Email invalide",
    emailNotFound: "Email introuvable. Veuillez réessayer la procédure d'inscription.",
    verificationFailed: "La vérification a échoué. Veuillez réessayer.",
    invalidLink: "Lien de vérification invalide.",
    pendingInvitation: "Erreur lors de la vérification des invitations en attente",
    accept: "Erreur lors de l'acceptation de l'invitation",
    decline: "Erreur lors du refus de l'invitation",
    loadInvitation: "Erreur lors du chargement de l'invitation",
    
    // Ajouts
    accountExists: "Un compte existe déjà avec cet email",
    emailInUse: "Cet email est déjà utilisé",
    networkError: "Erreur réseau",
    operationNotAllowed: "Opération non autorisée",
    popupCancelled: "Opération annulée",
    tooManyRequests: "Trop de tentatives, veuillez réessayer plus tard",
    weakPassword: "Le mot de passe est trop faible",
    wrongPassword: "Mot de passe incorrect",
    userNotFound: "Utilisateur non trouvé",
    default: "Une erreur s'est produite"
  },
  
  facebook: {
      accountExists: {
        description: "Un compte existe déjà avec cet email associé à une autre méthode de connexion.",
        step1: "Connectez-vous avec votre méthode habituelle",
        step2: "Liez votre compte Facebook dans les paramètres",
        title: "Compte existant"
      },
      general: {
        privacy: "Confidentialité",
        privacyText: "Nous ne publierons jamais rien sur votre mur sans votre permission.",
        tip1: "Assurez-vous que les pop-ups sont autorisés",
        tip2: "Vérifiez que vous êtes connecté à Facebook",
        tip3: "Autorisez l'accès à votre email",
        tip4: "Si l'erreur persiste, essayez un autre navigateur",
        tip5: "Ou utilisez l'email et le mot de passe",
        title: "Connexion avec Facebook"
      },
      popupBlocked: {
        description: "Le navigateur a bloqué la fenêtre de connexion Facebook.",
        note: "Note",
        noteText: "Si le problème persiste, essayez de désactiver temporairement votre bloqueur de publicité.",
        step1: "Recherchez l'icône de blocage dans la barre d'adresse",
        step2: "Cliquez dessus et autorisez les pop-ups pour ce site",
        step3: "Réessayez de vous connecter",
        title: "Pop-up bloqué"
      },
      unauthorizedDomain: {
          title: "Domaine non autorisé",
          description: "Ce domaine n'est pas autorisé pour l'authentification Facebook.",
          note: "Note",
          noteText: "Veuillez contacter l'administrateur."
      },
      understood: "J'ai compris"
  },
  
  // Messages d'avertissement
  webViewWarning: "Pour vous connecter avec Google, veuillez ouvrir cette page dans un navigateur standard comme Safari, Chrome ou Firefox.",
  
  // Autres clés
  signIn: "Se connecter"
};
